import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../config/api';
import { toast } from 'react-toastify';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      setUser(userData);
    }
    setLoading(false);
  }, []);

  const login = async (usuario, senha) => {
    try {
      const response = await api.post('/admin/login', {
        usuario,
        senha
      });

      const { token } = response.data;
      const userData = { usuario };

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
      
      toast.success('Login realizado com sucesso!');
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      throw new Error('Usuário ou senha inválidos');
    }
  };

  const logout = (showMessage = true) => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    
    if (showMessage) {
      toast.info('Sessão encerrada');
    }
  };

  // Função para logout automático (chamada quando token expira)
  const autoLogout = (reason = 'Sessão expirada') => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    
    toast.warning(`${reason}. Você será redirecionado para o login.`);
    
    // Redirecionar após um pequeno delay
    setTimeout(() => {
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }, 2000);
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, autoLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
}; 